import styled from '@emotion/styled';
import { media, theme } from '@vfit/shared/themes';

export const CustumHtlmDescription = styled.div`
  p {
    font-size: ${theme.typography.fontSize.body2};
    line-height: ${theme.typography.lineHeight.body2};
    color: ${theme.colors.text.primary};
  }
`;

export const ParagraphContainer = styled.p`
  margin: 0;
`;

export const Address = styled.h5`
  text-align: left;
  font-family: ${theme.typography.fontFamily.secondary};
  font-weight: ${theme.typography.fontWeight.light};
  font-size: ${theme.typography.fontSize.h6};
  line-height: ${theme.typography.lineHeight.h6};
  margin: ${theme.spacing.md} 0 ${theme.spacing.lg};
  b {
    font-family: ${theme.typography.fontFamily.secondary};
    font-weight: ${theme.typography.fontWeight.bold};
  }
  ${media.desktop`
    margin: ${theme.spacing['3xl']} 0 ${theme.spacing['2xl']};
    b {
      font-family: ${theme.typography.fontFamily.secondary};
      font-weight: ${theme.typography.fontWeight.regular};
    }
  `}
`;

export const Title = styled(ParagraphContainer)`
  margin-top: 32px;
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.h4};
  line-height: ${theme.typography.lineHeight.h4};
  color: ${theme.colors.text.primary};

  ${media.desktop`
    margin-top: ${theme.spacing['2xl']};
    font-size: ${theme.typography.fontSize.h2};
    line-height: ${theme.typography.lineHeight.h2};
  `}
`;

export const OffersList = styled.ul`
  margin-top: ${theme.spacing['2xl']};
  margin-bottom: ${theme.spacing['2xl']};
  padding: 0;

  li {
    list-style: none;
    font-family: ${theme.typography.fontFamily.secondary};
  }

  ${media.desktop`
    margin-bottom: ${theme.spacing['2xl']};
  `}
`;

export const PriceBlock = styled.div`
  header {
    display: block;
  }
`;

export const Paragraph = styled.div`
  p,
  span {
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.regular};
    font-size: ${theme.typography.fontSize.body1};
    line-height: ${theme.typography.lineHeight.body2};
    color: ${theme.colors.text.mvaSecondary};
  }

  div {
    margin: 0;
    margin-top: ${theme.spacing.md};
  }

  ${media.desktop`
    div {
      margin: 0;
      margin-top: ${theme.spacing.sm};
    }
  `}
`;

export const ParagraphBold = styled(Paragraph)`
  font-weight: ${theme.typography.fontWeight.bold};
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body1};
  color: ${theme.colors.text.primary};

  ${media.desktop`
    margin-top: ${theme.spacing.lg};
  `}
`;

export const PriceContainer = styled(Title)`
  margin-top: ${theme.spacing.md};
  p {
    margin: 0;
  }

  .rec {
    font-size: ${theme.typography.fontSize.h5};
    line-height: ${theme.typography.lineHeight.h6};
  }

  ${media.desktop`
    margin-top: ${theme.spacing.sm};

    .rec {
      font-size: ${theme.typography.fontSize.h5};
      line-height: ${theme.typography.lineHeight.h6};
    }
  `}
`;

export const Description = styled.div`
  p,
  span {
    font-size: ${theme.typography.fontSize.body2};
    line-height: ${theme.typography.lineHeight.body3};
    color: ${theme.colors.text.primary};
  }

  div {
    margin: 0;
    margin-top: ${theme.spacing.sm};
  }

  ${media.desktop`
    div {
      margin: 0;
      margin-top: ${theme.spacing.xs};
    }
  `}
`;

export const Spacer = styled.div`
  ${media.desktop`
    padding-top: ${theme.spacing.md};
  `}
`;

export const Container = styled.div`
  padding: 0;
  ${media.desktop`
    padding: ${theme.spacing.md} ${theme.spacing['2xl']};
  `}
`;

